/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDescriptionAdditionalOptions_item = {
    readonly isJewelry: boolean | null;
    readonly isCustomizable: boolean | null;
    readonly attributes: {
        readonly customizable: ReadonlyArray<{
            readonly text: string | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDescriptionAdditionalOptionsContent_item">;
    readonly " $refType": "PdpSharedDescriptionAdditionalOptions_item";
};
export type PdpSharedDescriptionAdditionalOptions_item$data = PdpSharedDescriptionAdditionalOptions_item;
export type PdpSharedDescriptionAdditionalOptions_item$key = {
    readonly " $data"?: PdpSharedDescriptionAdditionalOptions_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDescriptionAdditionalOptions_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDescriptionAdditionalOptions_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isJewelry",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCustomizable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemAttributes",
      "kind": "LinkedField",
      "name": "attributes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeValue",
          "kind": "LinkedField",
          "name": "customizable",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDescriptionAdditionalOptionsContent_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = 'edd73060e0ae4844837f52967ed3179d';
export default node;
